import { Button } from '@cottage/design-system/internal-tooling/ui'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

type ScheduleHealedBannerProps = {
  to: number | null
  healed: boolean
  reason?: 'pref_accrual'
  showRefresh: boolean
  onRefresh: () => void
  refreshing?: boolean
}

export default function ScheduleHealedBanner({
  to,
  healed,
  reason,
  showRefresh,
  onRefresh,
  refreshing = false,
}: ScheduleHealedBannerProps) {
  if (to == null && reason !== 'pref_accrual') {
    return null
  }
  const message = healed
    ? reason === 'pref_accrual'
      ? 'Waterfall split refreshed to add the projected preferred return — save to keep'
      : `Waterfall split refreshed after distribution #${to} was logged — save to keep`
    : reason === 'pref_accrual'
      ? 'Waterfall split predates the projected preferred return — Refresh to recompute'
      : `Waterfall split is out of date (distribution #${to} logged / month closed) — Refresh to recompute`
  return (
    <div
      className="mt-3 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-amber-950"
      role="status"
    >
      <div className="flex min-w-0 flex-1 items-start gap-3">
        <ExclamationTriangleIcon
          className="mt-0.5 h-5 w-5 shrink-0 text-amber-600"
          aria-hidden
        />
        <span className="text-sm leading-relaxed">{message}</span>
      </div>
      {showRefresh ? (
        <Button variant="outline" size="sm" disabled={refreshing} onClick={onRefresh}>
          Refresh
        </Button>
      ) : null}
    </div>
  )
}
